<template>
  <div>
    <!-- 遮罩层 -->
    <div
      v-if="visible"
      class="custom-modal"
      :style="modalStyle"
      @click="close"
    ></div>
    <!-- 弹框 -->
    <el-dialog   
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="visible"
      :custom-class="customClass"
      :style="dialogStyle"
      :modal="false"
      :append-to-body="false"
      :modal-append-to-body="false"
      @close="handleClose"
      :close-on-click-modal="false"
      :show-close="false"
      :top="top"
    >
      <slot />
      <template v-for="(_, name) in $slots" v-slot:[name]="slotProps">
        <slot :name="name" v-bind="slotProps" />
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'BaseDialog',
  inheritAttrs: false,
  data() {
    return {
      top:"15vh",
      visible: false,
      customClass: '',
      dialogStyle: {},
      modalStyle: {},
      targetClass: ''
    }
  },
  mounted(){
      window.addEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize(){
  this.$nextTick(() => {
        const target = document.querySelector(`.${this.targetClass}`);
        if (target) {
          const rect = target.getBoundingClientRect();
         
          // 遮罩层样式
          this.modalStyle = {
            position: 'fixed',
            left: rect.left + 'px',
            top: rect.top + 'px',
            width: rect.width + 'px',
            height: rect.height + 'px',
            background: '#787D94',
            zIndex: 2000
          };
          // 弹框定位
          const dialog = this.$el.querySelector('.el-dialog');
          if (dialog) {
             
            const dialogWidth = dialog.offsetWidth;
            const dialogHeight = dialog.offsetHeight;
            console.log(rect,dialogHeight);
            const left = rect.left;
            const top = (rect.height-dialogHeight)/2+rect.top;
            this.top = top+"px";
            console.log(top);
            this.dialogStyle = {
              position: 'fixed',
              left: left + 'px',
              zIndex: 2001
            };
          }
        }
      });
    },
    open(targetClass) {
      this.targetClass = targetClass;
      this.visible = true;
      this.$nextTick(() => {
        const target = document.querySelector(`.${targetClass}`);
        if (target) {
          const rect = target.getBoundingClientRect();
         
          // 遮罩层样式
          this.modalStyle = {
            position: 'fixed',
            left: rect.left + 'px',
            top: rect.top + 'px',
            width: rect.width + 'px',
            height: rect.height + 'px',
            background: '#787D94',
            zIndex: 2000
          };
          // 弹框定位
          const dialog = this.$el.querySelector('.el-dialog');
          if (dialog) {
            const dialogWidth = dialog.offsetWidth;
            const dialogHeight = dialog.offsetHeight;
            console.log(rect,dialogHeight);
            const left = rect.left;
            const top = (rect.height-dialogHeight)/2+rect.top;
            this.top = top+"px";
            console.log(top);
            this.dialogStyle = {
              position: 'fixed',
              left: left + 'px',
              zIndex: 2001
            };
          }
        }
      });
    },
    handleClose() {
       console.log("??????")
      this.visible = false;
      this.dialogStyle = {};
      this.modalStyle = {};
      this.$emit('close');
     
    },
    close() {
      // 可选：点击遮罩关闭弹窗
      this.handleClose();
    }
  }
}
</script>

<style scoped>
>>> .el-dialog {

  height: 396px;
}
>>> .el-dialog__body{
   height: 340px;
   padding: 0;
}
.custom-modal {
  /* 可自定义动画、样式 */
}
</style>


// WEBPACK FOOTER //
// src/view/managePages/components/custom-dialog.vue